/**
 * Automy.Core.Enums.Reporting.Operations.ReportExportFormat
 * JSON `exportFormat` (string token, lowercase). Pdf = 1, Pptx = 2, Png = 3.
 * UX sends the token. Power BI REST uses PDF / PPTX / PNG internally.
 */
export default Object.freeze({
  Pdf: 'pdf',
  Pptx: 'pptx',
  Png: 'png',
});

export const ReportExportFormatString = Object.freeze({
  pdf: 'pdf',
  pptx: 'pptx',
  png: 'png',
});
